import React from 'react';
import store from '../../../../store';
// Popup imports
import { OpenPopup } from '../../../../actions/popupActions';
import { PopupTypes, PopupStates } from '../../../Popup/Enums';
import LevelSettingsModeEnum from '../../../Popup/Types/LevelSettings/enums';
import settings from '../../../../../settings';
// Game(kit) imports
import gameKit from '../../../../../GameKit';

class BtnSettings extends React.Component {
    handleClick = () => {
        store.dispatch(
            OpenPopup(PopupTypes.LEVEL_SETTINGS, PopupStates.DEFAULT, {
                mode: LevelSettingsModeEnum.MAIN,
                levelUuid: gameKit.levelEditor.level.uuid
            })
        );
    };

    render = () => {
        const { className } = this.props;

        return (
            <div id="le-btn-settings" className={`${className}`} type="button" onClick={this.handleClick}>
                <img draggable="false" alt="instellingen" src={`${settings.assetsPath}img/icons/settings_green.png`} />
            </div>
        );
    };
}

export default BtnSettings;
